<template>
  <div>
    <home-banner
      title="档案管理新闻与咨询"
      description="由纸质档案向电子化档案转型的必选工具。"
    />
    <oldInfoList></oldInfoList>
  </div>
</template>
  
  <script>
import homeBanner from "./components/homeBanner.vue";
import oldInfoList from "./components/oldInfoList.vue";
export default {
  components: {
    homeBanner,
    oldInfoList,},
  data() {
    return {};
  },
};
</script>
  
<style lang="scss" scoped>
</style>